<div class="lg-dropdown-popup__wrapper" cdkTrapFocus>
    <div class="lg-dropdown-popup__main">
        <div class="lg-dropdown-popup__entries options">
            <div
                *ngFor="let option of optionsList"
                class="lg-dropdown-popup__entries__entry"
                [ngClass]="{
                    'lg-dropdown-popup__entries__entry--selected': option.code === currentId
                }"
                (click)="onClick($event, option)"
            >
                <span
                    *ngIf="option.code !== 0"
                    class="flag-options option--{{ option.type }} icon lg-icon"
                >
                    <svg viewBox="1 0 24 24"><use xlink:href="#icon-flag-filled"></use></svg>
                </span>
                <span
                    *ngIf="option.code === 0"
                    class="icon lg-icon flag-options option--{{ option.code }}"
                ></span>
                <span class="lg-dropdown-popup__entries__entry__name">{{
                    option.name | lgTranslate
                }}</span>
            </div>
        </div>
    </div>
</div>
